/* eslint-disable import/no-unresolved */
import { useEffect, useRef } from 'react';
import * as maplibregl from 'maplibre-gl';
import markerIcon from '@img/icons/map-marker-alt-filled.svg?raw';

import { useMaplibreMap } from '../MaplibreMap/maplibre-map.context';

import './markers.css';

function Markers({
  selectedMarker,
  setSelectedMarker,
  markers,
  fitToMarkers = true,
}) {
  const hasFittedBoundsRef = useRef(false);

  const { map, isLoading } = useMaplibreMap();

  useEffect(() => {
    if (!map || isLoading || hasFittedBoundsRef.current || !fitToMarkers) {
      return undefined;
    }

    const bounds = new maplibregl.LngLatBounds();

    markers.forEach(({ coordinates }) => {
      bounds.extend(coordinates);
    });

    map.fitBounds(bounds, { padding: 100 });

    hasFittedBoundsRef.current = true;

    return undefined;
  }, [isLoading, map, markers, fitToMarkers]);

  useEffect(() => {
    if (!map || isLoading) {
      return undefined;
    }

    const localMarkers = markers.map((caseStudy) => {
      const button = document.createElement('button');
      const label = document.createElement('span');
      const marker = document.createElement('span');
      const isSelected = selectedMarker === caseStudy.id;

      button.type = 'button';
      button.className = `marker${isSelected ? ' marker--selected' : ''}`;
      button.setAttribute('aria-label', caseStudy.label);

      label.className = 'marker-label';
      label.textContent = caseStudy.label;

      marker.className = 'marker-pin';
      marker.innerHTML = markerIcon;

      button.addEventListener('click', () => {
        setSelectedMarker(caseStudy.id);
      });

      button.append(label, marker);

      return new maplibregl.Marker({
        anchor: 'bottom',
        element: button,
      })
        .setLngLat(caseStudy.coordinates)
        .addTo(map);
    });

    return () => {
      localMarkers.forEach((marker) => {
        marker.remove();
      });
    };
  }, [isLoading, map, markers, selectedMarker, setSelectedMarker]);

  return null;
}

export default Markers;
